import Vue from 'vue'

Vue.directive('trans', {
  bind(el, binding, _vnode) {
    el.innerHTML = gettext(binding.value)
    el.removeAttribute('data-trans')
  },
})

Vue.directive('on-escape', {
  bind(el, binding, _vnode) {
    el.customEventKeydown = function (event) {
      if (event?.keyCode === 27) {
        if (typeof binding.value === 'function') {
          binding.value(event)
        } else {
          console.warn('v-on-escape: provided expression is not a function.')
        }
      }
    }
    document.body.addEventListener('keydown', el.customEventKeydown)
  },
  unbind(el) {
    document.body.removeEventListener('keydown', el.customEventKeydown)
  },
})

Vue.directive('click-outside', {
  bind(el, binding, _vnode) {
    el.clickOutsideEvent = function (event) {
      // Check if the click was outside the el and its children
      if (
        !(el == event.target || el.contains(event.target)) &&
        document.body.contains(event.target)
      ) {
        if (typeof binding.value === 'function') {
          binding.value(event)
        } else {
          console.warn('v-click-outside: provided expression is not a function.')
        }
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    // Clean up the event listener
    document.removeEventListener('click', el.clickOutsideEvent)
  },
})
